import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Observable, tap} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";
const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private tokenKey = 'authToken';
  private userPermissions: string[] = [];
  private userLogged: any = {};

  constructor(private router: Router, private http: HttpClient) {}

  logout(): void {
    localStorage.removeItem(this.tokenKey);
    this.router.navigate(['/login']);
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem(this.tokenKey);
  }

  setUser(user: any): void {
    this.userLogged = user;
  }

  getUser(): any {
    return this.userLogged;
  }

  getDataUser(): any {
    const body = JSON.stringify(this.userLogged);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/permission/getdatauser`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  setPermissions(permissions: string[]): void {
    this.userPermissions = permissions;
  }

  getPermissions(): string[] {
    return this.userPermissions;
  }

  hasPermission(module: string): boolean {
    return this.userPermissions.includes(module);
  }

  /**
   * Login
   */
  login(data:any): Observable<any>{
    const body = JSON.stringify(data);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/permission/login`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * Add client
   */
  addClient(data:any): Observable<any>{
    const body = JSON.stringify(data);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/client/create`,
        body,
        { headers }
    ).pipe(
        tap((response) => {
          if (response.success) { // Suponiendo que el backend devuelve un token
            localStorage.setItem(this.tokenKey, JSON.stringify(response.message));
          }
          this.controlLoader(false);
        })
    );
  }

  /*
  * Función para actualizar contraseña
   */
  changePass(data: any): Observable<any>{
    const body = JSON.stringify(data);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/client/changepass`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * Función para mostrar o remover loading
   */
  controlLoader(show:boolean):void{
    // let elemet: any = document.getElementsByClassName("loader-screen")[0];
    // elemet.style.opacity = 0.8;
    // elemet.style.display = elemet.style.display === 'none' ? '' : 'none';
  }
}
